export interface TeamMember {
  id: string;
  name: string;
  role: string;
  bio: string;
  linkedinUrl?: string;
  imagePath?: string;
  isCofounder?: boolean;
  isAI?: boolean;
  order: number;
  internalAchievements?: string[];
}

const teamMembers: TeamMember[] = [
  {
    id: 'miles-maggio',
    name: 'Miles Maggio',
    role: '',
    bio: 'Top voice in AI agent engineering with 3+ years of experience. Startup advisor to several AI startups. Led a successful startup exit and now architects the AI agent platform powering prest0.',
    linkedinUrl: 'https://www.linkedin.com/in/milesprest0/',
    imagePath: '/miles-maggio-profile.webp',
    isCofounder: true,
    order: 1,
  },
  {
    id: 'justin-zelaya',
    name: 'Justin Zelaya',
    role: '',
    bio: '1st place at the National Security Hackathon (CIA). Built multiple breakout and viral products with strong GTM traction. Drives go-to-market strategy, growth, and visibility at prest0.',
    linkedinUrl: 'https://www.linkedin.com/in/justin-zelaya-2236b5292/',
    imagePath: '/team/justin-zelaya.webp',
    isCofounder: true,
    order: 2,
  },
  {
    id: 'prest0n',
    name: 'Prest0n',
    role: 'Internal AI Agent & Operations Partner',
    bio: "prest0's internal autonomous agent. Operates with advanced semantic memory and compound reasoning to deploy real software, commit verified code, write business strategy, execute GitHub/CI configurations, handle integrations, and autonomously coordinate development with the human team.",
    imagePath: '/images/project-olivia-logo.webp?v=20260715',
    isAI: true,
    order: 3,
    internalAchievements: [
      "Shipped 100+ production commits across 6 weeks spanning every layer of the stack — React frontend, TypeScript backend, Cloud Functions, Firestore, GCS, GCE, and AI agent infrastructure — autonomously, without pair programming.",
      "Architected and fully deployed automated VM provisioning for trial users: Firestore state orchestration, GCE instance creation, live IP routing, cold-boot detection, and real-time status banners shown to users during onboarding — end-to-end, zero human steps.",
      "Designed and shipped a multi-VM agentic backend on Google Cloud: per-account session isolation, cross-VM tool bridge routing, agent context forwarding, and per-account prompt/memory injection across all tenants simultaneously.",
      "Built the complete Stripe billing system from scratch: subscription lifecycle management, webhook verification, trial activation gates, access-code redemption, and Firestore sync — handling real money with zero billing incidents.",
      "Engineered server-side document intelligence pipeline: multi-format extraction (PDF, DOCX, images), Cloud Function orchestration, 40k-char intelligent truncation, fallback metadata recovery, and real-time streaming to agent VM — processes files users upload in under 3 seconds.",
      "Rebuilt the entire prest0.ai public website from pitch-deck source of truth — Home, Team, Mission, and Footer — pixel-perfect and fully responsive, deployed to GCS with CDN cache control, in under 2 weeks.",
      "Implemented deep agentic research as a production tool — multi-stage web research pipeline with streaming synthesis, source citation, and structured legal-grade output — live for paying customers.",
      "Resolved 35+ critical production bugs autonomously: SSE streaming race conditions, stale localStorage hydration crashes, CDN cache poisoning, VM cold-boot timeouts, type-safety gaps across 10k+ lines of TypeScript, and Firestore consistency edge cases.",
      "Deployed and maintained real-time voice infrastructure: Twilio webhook integration, TTS routing, per-account VM voice sessions, and public HTTPS endpoint management across multiple GCP VMs.",
      "Executed all GCP infrastructure operations without GUI access: GCS bucket syncs, Load Balancer CDN invalidations, Cloud Function versioned deployments, Firestore config propagation, and service account permission management — all via CLI and SDK.",
      "Implemented full SEO infrastructure: per-page dynamic meta tags, Open Graph, Google Search Console verification, sitemap generation, WebP image optimization, and prest0.ai domain migration — shipped in a single sprint.",
      "Managed, debugged, and extended a 15,000+ line production React/TypeScript codebase with zero regressions — while simultaneously shipping new features, fixing live bugs, and coordinating with the team in real time."
    ],
  },
  {
    id: 'gary-fowler',
    name: 'Gary Fowler',
    role: 'Advisor, AI & Global Scale',
    bio: "Two enterprise software exits: led GTM at ClickSoftware through its Nasdaq IPO (CKSW, acquired by Salesforce for $1.35B); co-founded Yva.ai (acquired by Visier). Runs GSD Venture Studios. TEDx, UN, and Forbes speaker. Advises prest0 on GTM, enterprise intros, and executive recruiting.",
    linkedinUrl: 'https://www.linkedin.com/in/fowlerinternational/',
    imagePath: '/team/gary-fowler.webp',
    order: 4,
  },
  {
    id: 'fernando-hidalgo',
    name: 'Fernando Hidalgo',
    role: 'Advisor, Law',
    bio: "Immigration attorney with 19+ years of experience. CEO of The Law Offices of Fernando Hidalgo, Inc. Bilingual in English and Spanish. Daily input on how to improve the Prest0 platform and Prest0n's capabilities to be very useful for enterprise law firms.",
    linkedinUrl: 'https://www.linkedin.com/in/fernando-hidalgo-62b34143/',
    imagePath: '/team/fernando-hidalgo.webp',
    order: 5,
  },
  {
    id: 'aditya-bhatia',
    name: 'Aditya Bhatia',
    role: 'Advisor, Memory, Design & Startup',
    bio: 'Y Combinator alumnus (W18). Successful startup founder. Design and product expert bringing deep experience in memory architectures and product strategy to prest0.',
    linkedinUrl: 'https://www.linkedin.com/in/adityabhatia89/',
    imagePath: '/team/aditya-bhatia.webp',
    order: 6,
  },
  {
    id: 'malaika-majeed',
    name: 'Malaika Majeed',
    role: 'Agentic Manager',
    bio: "With Miles, drives product and project implementation across prest0's platform. Manages internal AI agent Prest0n to execute up to 15 projects in parallel, ensuring every feature ships polished and aligned with our core mission.",
    imagePath: '/team/malaika-majeed.webp',
    order: 7,
  },
];

export default teamMembers;
